import Loadable from 'my-components/Loadable';

export const pluginPresets = {
  BASIC: { equation: true, link: true },
  COMMON: { inlineStyles: true, equation: true, colors: true, link: true, image: true },
  ALL: {
    equation: true,
    fillInTheBlank: true,
    alignment: true,
    lineSpacing: true,
    link: true,
    tooltip: true,
    image: true,
    video: true,
    listTypes: true,
    headerTypes: true,
    supSub: true,
    inlineStyles: true,
    colors: true,
    copyPaste: true,
    rawLatexInput: true,
  },
};

export { default as LoadingFallback } from './LoadingFallback';
export { default as SolutionStepsEditor } from './SolutionStepsEditor';

export default Loadable(() => import(/* webpackChunkName: "editor" */ './EditorError'), { hideLoader: true });
export const EditorChat = Loadable(() => import(/* webpackChunkName: "editor" */ './EditorChat'), { hideLoader: true });
export const HighlightEditor = Loadable(() => import(/* webpackChunkName: "editor" */ './HighlightEditor'), {
  hideLoader: true,
});
